// Princeton's undergraduate departmental majors (#2596, founder 2026-09-30:
// "majors offered by the college in the public page"). Read on 2026-09-30
// from Princeton's official Undergraduate Announcement (ua.princeton.edu),
// its two Fields of Study pages: Departmental Majors for the Degree of
// Bachelor of Arts and for the Degree of Bachelor of Science in Engineering.
// The Announcement now says "departmental majors" (the older
// "departmental concentrations" page is gone, 404). The pages give no
// abbreviation; A.B. and B.S.E. are Princeton Admission's own (Degrees and
// Departments page). Computer Science is offered for both degrees and appears
// in both groups. Minors and certificate programs are left out. No flags: the
// college file holds no programs source. The KB list was the starting point;
// the Announcement wins.
const majors = {
    "slug": "princeton-university",
    "read": "2026-09-30",
    "intro": "Every departmental major in Princeton's official Undergraduate Announcement, grouped by the degree it leads to, the A.B. or the B.S.E. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Departmental majors for the Bachelor of Arts",
            "source": {
                "label": "Princeton Undergraduate Announcement, Departmental Majors for the Degree of Bachelor of Arts",
                "url": "https://ua.princeton.edu/fields-study/departmental-majors-degree-bachelor-arts"
            },
            "majors": [
                {
                    "name": "African American Studies",
                    "degree": "A.B."
                },
                {
                    "name": "Anthropology",
                    "degree": "A.B."
                },
                {
                    "name": "Architecture",
                    "degree": "A.B."
                },
                {
                    "name": "Art and Archaeology",
                    "degree": "A.B."
                },
                {
                    "name": "Astrophysical Sciences",
                    "degree": "A.B."
                },
                {
                    "name": "Chemistry",
                    "degree": "A.B."
                },
                {
                    "name": "Classics",
                    "degree": "A.B."
                },
                {
                    "name": "Comparative Literature",
                    "degree": "A.B."
                },
                {
                    "name": "Computer Science",
                    "degree": "A.B."
                },
                {
                    "name": "East Asian Studies",
                    "degree": "A.B."
                },
                {
                    "name": "Ecology and Evolutionary Biology",
                    "degree": "A.B."
                },
                {
                    "name": "Economics",
                    "degree": "A.B."
                },
                {
                    "name": "English",
                    "degree": "A.B."
                },
                {
                    "name": "French and Italian",
                    "degree": "A.B."
                },
                {
                    "name": "Geosciences",
                    "degree": "A.B."
                },
                {
                    "name": "German",
                    "degree": "A.B."
                },
                {
                    "name": "History",
                    "degree": "A.B."
                },
                {
                    "name": "Linguistics",
                    "degree": "A.B."
                },
                {
                    "name": "Mathematics",
                    "degree": "A.B."
                },
                {
                    "name": "Molecular Biology",
                    "degree": "A.B."
                },
                {
                    "name": "Music",
                    "degree": "A.B."
                },
                {
                    "name": "Near Eastern Studies",
                    "degree": "A.B."
                },
                {
                    "name": "Neuroscience",
                    "degree": "A.B."
                },
                {
                    "name": "Philosophy",
                    "degree": "A.B."
                },
                {
                    "name": "Physics",
                    "degree": "A.B."
                },
                {
                    "name": "Politics",
                    "degree": "A.B."
                },
                {
                    "name": "Princeton School of Public and International Affairs",
                    "degree": "A.B."
                },
                {
                    "name": "Psychology",
                    "degree": "A.B."
                },
                {
                    "name": "Religion",
                    "degree": "A.B."
                },
                {
                    "name": "Slavic Languages and Literatures",
                    "degree": "A.B."
                },
                {
                    "name": "Sociology",
                    "degree": "A.B."
                },
                {
                    "name": "Spanish and Portuguese",
                    "degree": "A.B."
                }
            ]
        },
        {
            "name": "Departmental majors for the Bachelor of Science in Engineering",
            "source": {
                "label": "Princeton Undergraduate Announcement, Departmental Majors for the Degree of Bachelor of Science in Engineering",
                "url": "https://ua.princeton.edu/fields-study/departmental-majors-degree-bachelor-science-engineering"
            },
            "majors": [
                {
                    "name": "Chemical and Biological Engineering",
                    "degree": "B.S.E."
                },
                {
                    "name": "Civil and Environmental Engineering",
                    "degree": "B.S.E."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S.E."
                },
                {
                    "name": "Electrical and Computer Engineering",
                    "degree": "B.S.E."
                },
                {
                    "name": "Mechanical and Aerospace Engineering",
                    "degree": "B.S.E."
                },
                {
                    "name": "Operations Research and Financial Engineering",
                    "degree": "B.S.E."
                }
            ]
        }
    ]
};

export default majors;
